import { render, staticRenderFns } from "./TrackingPayPalHead.vue?vue&type=template&id=4dfc669c&scoped=true"
import script from "./TrackingPayPalHead.vue?vue&type=script&lang=js"
export * from "./TrackingPayPalHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfc669c",
  null
  
)

export default component.exports